<template>
  <div class="modal-mask" v-show="showModal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-body">
          <!-- VIDEO PLAYER HERE -->
          <div v-if="showPlayer" class="video-player-container">
            <video-player></video-player>
          </div>

          <!-- PROGRESS PATH HERE -->
          <div v-if="showProgress" class="progressScreen">
            <progress-path></progress-path>
          </div>

          <!-- CERTIFICATE -->
          <div v-if="showCertificate" class="certScreen">
            <certificate></certificate>
          </div>

          <!-- ERROR -->
          <div v-if="showError" class="errorScreen">
            <oops
              :hide-tell-teacher="modalData && modalData.hideTellTeacher"
            ></oops>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Certificate from './Certificate.vue';
import Oops from './Oops.vue';
import ProgressPath from './ProgressPath.vue';
import VideoPlayer from './VideoPlayer.vue';

export default {
  data() {
    return {
      showPlayer: false,
      showProgress: false,
      showCertificate: false,
      showError: false,
      showModal: false,
      modalData: null
    };
  },

  computed: {
    ...mapState('application', ['modal']),
    ...mapState('activity', {
      activityData: state => state.data
    })
  },

  watch: {
    modal() {
      if (!this.modal) {
        this.setVideoAndIsVideoPathAbsolute({});
        this.triggerCloseModal();
        return;
      }

      if (this.currentModal) {
        this.triggerCloseModal();
      }

      this.$nextTick(() => {
        this.currentModal = this.modal;
        this.triggerShowModal(this.modal.type, this.modal.data);
      });
    }
  },

  components: {
    VideoPlayer,
    ProgressPath,
    Certificate,
    Oops
  },

  methods: {
    ...mapMutations('application', ['setVideoAndIsVideoPathAbsolute']),

    triggerCloseModal() {
      this.showPlayer = false;
      this.showProgress = false;
      this.showModal = false;
      this.showCertificate = false;
      this.showError = false;
      this.modalData = null;
    },

    triggerShowModal(modalType, modalData) {
      this.showModal = true;
      this.modalData = modalData;

      if (modalType === 'video') {
        this.showPlayer = true;
        this.showProgress = false;
        this.showCertificate = false;

        this.$nextTick(function() {
          this.setVideoAndIsVideoPathAbsolute({ video: modalData });
        });
      }

      if (modalType === 'homeRowVideo') {
        this.showPlayer = true;
        this.showProgress = false;
        this.showCertificate = false;

        this.$nextTick(function() {
          this.setVideoAndIsVideoPathAbsolute({ video: modalData });
        });
      }

      if (modalType === 'progress') {
        this.showPlayer = false;
        this.showProgress = true;
        this.showCertificate = false;
        this.showError = false;
      }

      if (modalType === 'cert') {
        this.showPlayer = false;
        this.showProgress = false;
        this.showCertificate = true;
        this.showError = false;
      }

      if (modalType === 'error') {
        this.showPlayer = false;
        this.showProgress = false;
        this.showCertificate = false;
        this.showError = true;
      }
    }
  }
};
</script>
